import * as maptilersdk from '@maptiler/sdk';

export class Tools {
    static getExtentFromGeojsonSource = (source) => {
        const extent = new maptilersdk.LngLatBounds();
        //console.log(source.data.features);
        source.data.features.forEach((feature) => {
            feature.geometry.coordinates.forEach((innerFeature) => {
                extent.extend(innerFeature);
            });
        });
        return extent;
    };

    static getCombinedExtent(...args) {
        const extent = new maptilersdk.LngLatBounds();
        args.forEach((arg) => {
            extent.extend(arg);
        });
        return extent;
    }
}
